import Vue from "vue";

import AccountHeader from "./MyAccountHeader.vue";

export function load() {
    const selector = "myaccount-header";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(AccountHeader, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
